// ** React Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Autocomplete,
    Alert,
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Fab,
    IconButton,
    Stack,
    Tab,
    Tooltip,
} from '@mui/material'

import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import appInfo from '../../../../configs/app-info';
import { getDoctag, getGudang, getProses } from '../../../../api/helper';
import { useToast } from '../../../../components/ToastProvider';
import moment from 'moment';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import Swal from 'sweetalert2';
import { TabContext, TabList, TabPanel } from '@mui/lab';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();
    const { id } = useParams();
    const { showToast, hideToast } = useToast();

    // Ambil value tab dari query param
    const [searchParams] = useSearchParams();
    const currentView = searchParams.get('view') || '0';
    const [search, setSearch] = useState('')
    const [searchBarang, setSearchBarang] = useState('')

    const qtyOpnameRef = useRef<HTMLInputElement>(null);

    const [tabs, setTabs] = useState<string>(currentView)
    const [idD, setIdD] = useState<any>(null)
    const [idGudang, setIdGudang] = useState<any>(null)
    const [listBarang, setListBarang] = useState<any[]>([])
    const [listData, setListData] = useState<any[]>([])
    const [masterData, setMasterData] = useState<any>(null)
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [openDialogBarang, setOpenDialogBarang] = useState<boolean>(false)
    const [selectedAlreadyExists, setSelectedAlreadyExists] = useState<boolean>(false)

    useEffect(() => {
        if (openDialog) {
            setTimeout(() => {
                qtyOpnameRef.current?.focus();
            }, 150);
        }
    }, [openDialog]);

    interface FormInputs {
        subgudang: any,
        pic: any,
        keterangan: any,
        tgl: any,
        link: any,

        qty_stock: any
        qty_opname: any
        qty_doc: any
        keterangan_detail: string
        mmbarang_id: any,
    }

    const defaultValues = {
    }

    const {
        control,
        watch,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const getDetail = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/gudang/stock-opname/detail-opname-new/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data
                    const master = data.master[0]

                    if (!master) {
                        showToast('Dokumen opname tidak ditemukan', 'error')
                        Swal.close()
                        return
                    }

                    setMasterData(master)
                    setValue('subgudang', master.gudang)
                    setIdGudang(master.mmgudang_id)
                    setValue('pic', master.pic)
                    setValue('keterangan', master.keterangan)
                    setValue('tgl', master.tgl)

                    const detail = response.data.detail.map((item: any) => ({
                        ...item,
                        id: String(item.id),
                        is_opname: item.keterangan ? 1 : 0
                    }));
                    setListData(detail)

                    Swal.close()
                } else {
                    showToast(response.data.message, 'error');
                    Swal.close()
                }
            })
            .catch(error => {
                Swal.close()
                showToast(error.response?.data?.message || error.message, 'error')
            })
    }

    useEffect(() => {
        getDetail();
    }, [])

    const getBarang = () => {
        setLoading(true)
        const url = apiUrl.apiUrl + '/gudang/stock-opname/get-barang/' + idGudang
        axios
            .get(url, {
                params: { opname_id: id },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBarang(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.response?.data?.message || error.message, 'error')
            })
            .finally(() => setLoading(false))
    }

    const setPayload = (rows: any) => {
        setLoading(false)
        setOpenDialogBarang(false)
        setOpenDialog(true)
        setSelectedAlreadyExists(Number(rows.sudah_dipilih) === 1)

        setValue('mmbarang_id', rows.id)

        setValue('qty_stock', rows.stock)
        setValue('qty_opname', rows.stock)
        setValue('keterangan_detail', `Opname Oleh ${getValues('pic')} pada ${moment().format('LL')}`)
        setIdD(rows.id)
    }

    const handleClick = (e: any) => {
        const selectedData = e.data;
        setPayload(selectedData)
    };

    const deleteTableRows = (rows: any) => {
        const url = apiUrl.apiUrl + '/gudang/stock-opname/delete-detail-opname/' + rows.id

        axios.post(url, {}, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getDetail()
                } else {
                    showToast(response.data.message, 'error');
                    setOpenDialog(false);
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            });
    };


    const ActionButtons = ({ row }: {
        row: any;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Cetak Label">
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open(
                                `${apiUrl.baseUrl}/mm/barang/cetak-label/${row.id_barang}`,
                                '_blank'
                            );
                        }}
                    >
                        <Icon icon={"mdi:qrcode"} />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Hapus detail dan batalkan penyesuaian stok">
                    <IconButton
                        color="error"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation()
                            Swal.fire({
                                title: 'Hapus barang?',
                                text: `${row.sku} - ${row.nama_barang}. Penyesuaian stok barang ini akan dibatalkan.`,
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'Hapus',
                                cancelButtonText: 'Batal'
                            }).then(result => result.isConfirmed && deleteTableRows(row))
                        }}
                    >
                        <Icon icon="mdi:trash-can-outline" />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                />
            ),
        },
    ];


    // tambahkan ini di dalam komponen
    const qtyStock = watch("qty_stock");
    const qtyOpname = watch("qty_opname");

    useEffect(() => {
        if (qtyStock !== undefined && qtyOpname !== undefined) {
            const stock = parseFloat(qtyStock) || 0;
            const opname = parseFloat(qtyOpname) || 0;
            const adjustment = stock - opname;
            setValue("qty_doc", adjustment, { shouldValidate: true });
        }
    }, [qtyStock, qtyOpname, setValue]);

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: string) => {
        navigate(`?view=${newValue}`);
        setTabs(newValue);
    };

    const filteredData = listData.filter((item: any) => {
        const keyword = search.toLowerCase()

        return (
            item.sku?.toLowerCase().includes(keyword) ||
            item.nama_barang?.toLowerCase().includes(keyword) ||
            item.barcode?.toLowerCase().includes(keyword)
        )
    })

    const filteredBarang = listBarang.filter((item: any) => {
        const keyword = searchBarang.toLowerCase()

        return (
            item.kode?.toLowerCase().includes(keyword) ||
            item.nama_barang?.toLowerCase().includes(keyword) ||
            item.jenis_barang?.toLowerCase().includes(keyword)
        )
    })

    const formatQty = (value: any) => new Intl.NumberFormat('id-ID', {
        maximumFractionDigits: 3
    }).format(Number(value) || 0)

    const summary = listData.reduce((result: any, item: any) => ({
        items: result.items + 1,
        system: result.system + Number(item.qty_system || 0),
        actual: result.actual + Number(item.qty_opname || 0),
        adjustment: result.adjustment + (Number(item.qty_opname || 0) - Number(item.qty_system || 0)),
        changed: result.changed + Number(item.stok_berubah || 0),
    }), { items: 0, system: 0, actual: 0, adjustment: 0, changed: 0 })

    const isDirectAdjustment = Number(masterData?.is_aktif) === 1



    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <Box
                    sx={{
                        maxWidth: 1200,
                        mx: 'auto',
                        py: 1
                    }}
                >
                    <Card sx={{ mb: 2, borderRadius: 3, overflow: 'hidden' }}>
                        <CardContent sx={{ color: 'common.white', background: 'linear-gradient(135deg, #3158d4 0%, #5c7cfa 100%)' }}>
                            <Box display='flex' flexDirection={{ xs: 'column', sm: 'row' }} justifyContent='space-between' gap={2}>
                                <Box>
                                    <Typography variant='overline' sx={{ opacity: .8 }}>Stock opname</Typography>
                                    <Typography variant='h5' fontWeight={800}>Dokumen {id}</Typography>
                                    <Typography variant='body2' sx={{ opacity: .9 }}>
                                        {moment(getValues('tgl')).format('LL')} · {getValues('pic') || '-'}
                                    </Typography>
                                </Box>
                                <Chip
                                    icon={<Icon icon={isDirectAdjustment ? 'mdi:check-decagram' : 'mdi:clock-outline'} />}
                                    label={masterData?.status || 'Memuat status'}
                                    color={isDirectAdjustment ? 'success' : 'warning'}
                                    sx={{ alignSelf: { xs: 'flex-start', sm: 'center' }, fontWeight: 700 }}
                                />
                            </Box>
                        </CardContent>
                        <Divider sx={{ m: 0 }} />
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        name="subgudang"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Sub Gudang"
                                                InputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Controller
                                        name="pic"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="PIC"
                                                InputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Controller
                                        name="keterangan"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                multiline
                                                rows={3}
                                                label="Keterangan"
                                                InputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        {[
                            { label: 'Total barang', value: summary.items, icon: 'mdi:package-variant-closed' },
                            { label: 'Stok sistem', value: formatQty(summary.system), icon: 'mdi:database-outline' },
                            { label: 'Hasil opname', value: formatQty(summary.actual), icon: 'mdi:clipboard-check-outline' },
                            { label: 'Net adjustment', value: formatQty(summary.adjustment), icon: 'mdi:swap-vertical-bold' },
                        ].map(item => (
                            <Grid item xs={6} md={3} key={item.label}>
                                <Card variant='outlined' sx={{ borderRadius: 3, height: '100%' }}>
                                    <CardContent sx={{ display: 'flex', gap: 1.5, alignItems: 'center', p: 2, '&:last-child': { pb: 2 } }}>
                                        <Box sx={{ bgcolor: '#eef2ff', color: 'primary.main', borderRadius: 2, p: 1, display: 'flex' }}>
                                            <Icon icon={item.icon} width={24} />
                                        </Box>
                                        <Box>
                                            <Typography variant='caption' color='text.secondary'>{item.label}</Typography>
                                            <Typography variant='h6' fontWeight={800}>{item.value}</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                    {/* ================= LIST SECTION ================= */}
                    <Card sx={{ borderRadius: 3 }}>
                        <CardContent>
                            {/* Header + Button */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    mb: 2
                                }}
                            >
                                <Typography variant="subtitle1" fontWeight={600}>
                                    Daftar Barang
                                </Typography>

                                <Button
                                    variant="contained"
                                    startIcon={<Icon icon="mdi:plus" />}
                                    sx={{ borderRadius: 5, textTransform: 'none', px: 3 }}
                                    onClick={() => {
                                        getBarang()
                                        setOpenDialogBarang(true)
                                    }}
                                >
                                    Tambah
                                </Button>
                            </Box>

                            <TabContext value={tabs}>
                                <TabList
                                    variant="fullWidth"
                                    onChange={handleChangeTabs}
                                    sx={{
                                        mb: 2,
                                        '& .MuiTab-root': {
                                            textTransform: 'none',
                                            fontWeight: 600
                                        }
                                    }}
                                >
                                    <Tab value="0" label="Desktop View" icon={<Icon icon="mdi:monitor" />} />
                                    <Tab value="1" label="Mobile View" icon={<Icon icon="mdi:cellphone" />} />
                                </TabList>

                                {/* ================= DESKTOP ================= */}
                                <TabPanel value="0">
                                    <MsiDatagrid
                                        array={listData}
                                        hiddenColumns={[
                                            'id',
                                            'mmgudang_sub_opname_id',
                                            'id_barang',
                                            'mmgudang_sub_id',
                                            'mmsatuan_id',
                                            'mmsatuan_doc_id',
                                            'created_at',
                                            'qty_system',
                                            'mmopname_id',
                                            'is_opname'
                                        ]}
                                        convertNumeric={['qty_opname', 'qty_adjustment', 'qty_stock_sekarang']}
                                        customRender={[
                                            {
                                                key: 'stok_berubah',
                                                renderCell: ({ value }: any) => Number(value) === 1
                                                    ? <Chip size='small' color='warning' label='Berubah' />
                                                    : <Chip size='small' color='success' variant='outlined' label='Sesuai' />
                                            },
                                            {
                                                key: 'qty_adjustment',
                                                renderCell: ({ value }: any) => (
                                                    <Typography fontWeight={700} color={Number(value) < 0 ? 'error.main' : Number(value) > 0 ? 'success.main' : 'text.secondary'}>
                                                        {formatQty(value)}
                                                    </Typography>
                                                )
                                            }
                                        ]}
                                        rowStyleRules={[
                                            { field: 'is_opname', operator: '==', value: 0, color: '#FFFDE7' },
                                            { field: 'is_opname', operator: '==', value: 1, color: '#E8F5E9' }
                                        ]}
                                        actions={actionData}
                                    />
                                </TabPanel>

                                {/* ================= MOBILE ================= */}
                                <TabPanel value="1">
                                    {/* Search */}
                                    <Box sx={{ mb: 2 }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Search SKU / Nama..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            InputProps={{
                                                startAdornment: <Icon icon="mdi:magnify" width={20} />
                                            }}
                                        />
                                    </Box>

                                    <Stack spacing={2}>
                                        {filteredData.map((item: any) => {
                                            const isDone = item.is_opname === 1
                                            const borderColor = isDone ? '#4caf50' : '#ffc107'

                                            return (
                                                <Card
                                                    key={item.id}
                                                    elevation={3}
                                                    sx={{
                                                        borderRadius: 3,
                                                        borderLeft: `6px solid ${borderColor}`,
                                                        transition: 'all 0.2s ease',
                                                        '&:hover': { boxShadow: 6 },
                                                        '&:active': { transform: 'scale(0.98)' }
                                                    }}
                                                >
                                                    <CardContent>
                                                        <Box display="flex" justifyContent="space-between">
                                                            <Box>
                                                                <Typography fontWeight={700}>
                                                                    {item.sku}
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary">
                                                                    {item.nama_barang}
                                                                </Typography>
                                                            </Box>

                                                            <Box
                                                                mt={2}
                                                                display="flex"
                                                                justifyContent="flex-end"
                                                                gap={1}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() =>
                                                                        window.open(
                                                                            `${apiUrl.baseUrl}/mm/barang/cetak-label/${item.id_barang}`,
                                                                            '_blank'
                                                                        )
                                                                    }
                                                                >
                                                                    <Icon icon="mdi:qrcode" />
                                                                </IconButton>
                                                            </Box>
                                                        </Box>

                                                        <Divider sx={{ my: 1.5 }} />

                                                        <Grid container spacing={1}>
                                                            <Grid item xs={6}>
                                                                <Typography variant="caption" color="text.secondary">
                                                                    Jenis
                                                                </Typography>
                                                                <Typography>{item.jenis_barang}</Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Typography variant="caption" color="text.secondary">
                                                                    Satuan
                                                                </Typography>
                                                                <Typography>{item.satuan}</Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Typography variant="caption" color="text.secondary">
                                                                    Qty System
                                                                </Typography>
                                                                <Typography fontWeight={600}>
                                                                    {item.qty_system}
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Typography variant="caption" color="text.secondary">
                                                                    Qty Opname
                                                                </Typography>
                                                                <Typography fontWeight={600}>
                                                                    {item.qty_opname}
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Typography variant="caption" color="text.secondary">
                                                                    Adjustment
                                                                </Typography>
                                                                <Typography fontWeight={600}>
                                                                    {formatQty(item.qty_adjustment)}
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Typography variant="caption" color="text.secondary">
                                                                    Dibuat
                                                                </Typography>
                                                                <Typography fontWeight={600}>
                                                                    {item.created_by} - {moment(item.created_at).format('LLL')}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            )
                                        })}
                                    </Stack>
                                </TabPanel>
                            </TabContext>
                        </CardContent>
                    </Card>
                </Box>

            </Grid>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => {
                    setOpenDialog(false)
                    getBarang()
                }}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit(async (data) => {
                    setLoading(true)
                    try {
                        const url = apiUrl.apiUrl + '/gudang/stock-opname/save-mmopname/' + id
                        const response = await axios.post(url, data, {
                            headers: { Authorization: `Bearer ${token}` }
                        })

                        if (!response.data.success) {
                            showToast(response.data.message, 'error')
                            return
                        }

                        showToast(response.data.message, 'success')
                        setOpenDialog(false)
                        getDetail()
                        getBarang()
                    } catch (error: any) {
                        showToast(error.response?.data?.message || error.message, 'error')
                    } finally {
                        setLoading(false)
                    }
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='h6' sx={{ fontWeight: 500, color: '#212121' }}>
                            Opname Barang
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers>
                        {selectedAlreadyExists && (
                            <Alert severity='info' sx={{ mb: 2 }}>
                                Barang ini sudah ada. Menyimpan akan memperbarui baris lama, bukan membuat duplikat.
                            </Alert>
                        )}
                        <Grid container spacing={3}>
                            {/* QTY SYSTEM */}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_stock"
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Quantity Awal"
                                                type="number"
                                                value={value}
                                                disabled
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty_stock && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {/* QTY ADJUSTMENT */}
                            <Grid item xs={12} sm={6} hidden>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_doc"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Quantity Adjustment"
                                                type="number"
                                                value={value}
                                                disabled
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty_doc && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* QTY OPNAME */}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_opname"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label="Quantity Opname"
                                                name="qty_opname"
                                                inputRef={qtyOpnameRef}
                                                value={
                                                    value !== undefined && value !== null && value !== ""
                                                        ? (() => {
                                                            // Format value for display: replace dot with comma, add thousand separator
                                                            const str = String(value).replace(".", ",");
                                                            const [integer, decimal] = str.split(",");
                                                            let formatted = integer
                                                                ? Number(integer).toLocaleString("id-ID")
                                                                : "";
                                                            if (decimal !== undefined) {
                                                                formatted += "," + decimal;
                                                            }
                                                            return formatted;
                                                        })()
                                                        : ""
                                                }
                                                onChange={(e) => {
                                                    let input = e.target.value;

                                                    // Remove all except digits and comma
                                                    input = input.replace(/[^0-9,]/g, "");

                                                    // Split integer and decimal part
                                                    const [intPart, decimalPart] = input.split(",");

                                                    // Format integer part with thousand separator
                                                    let formatted = "";
                                                    if (intPart) {
                                                        const parsed = parseInt(intPart, 10);
                                                        formatted = isNaN(parsed)
                                                            ? ""
                                                            : parsed.toLocaleString("id-ID");
                                                    }
                                                    if (decimalPart !== undefined) {
                                                        formatted += "," + decimalPart;
                                                    }

                                                    // Raw value for backend: replace comma with dot
                                                    const rawValue =
                                                        decimalPart !== undefined
                                                            ? `${intPart}.${decimalPart}`
                                                            : intPart;

                                                    setValue("qty_opname", rawValue);
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ inputMode: "decimal" }}
                                            />
                                        )}
                                    />
                                    {errors.qty_opname && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* KETERANGAN */}
                            <Grid item xs={12} sm={6} hidden>
                                <Typography variant="body1" sx={{ fontWeight: "bold", mb: 4 }}>
                                    Keterangan Opname
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name="keterangan_detail"
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                // inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Keterangan Opname"
                                                value={value}
                                                disabled
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_detail && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit' disabled={loading}>
                            {loading ? 'Menyimpan...' : 'Simpan'}
                        </Button>
                        <Button onClick={() => {
                            setOpenDialog(false)
                            getBarang()
                        }}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogBarang}
                onClose={() => setOpenDialogBarang(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='h6' sx={{ fontWeight: 500, color: '#212121' }}>
                        List Barang
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        fullWidth
                        size='small'
                        placeholder='Cari kode, nama, atau jenis barang...'
                        value={searchBarang}
                        onChange={(event) => setSearchBarang(event.target.value)}
                        sx={{ mb: 2 }}
                        InputProps={{
                            startAdornment: <Icon icon='mdi:magnify' width={20} />
                        }}
                    />
                    {loading ? (
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                            <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                        </Grid>
                    ) : (

                        <MsiDatagrid array={filteredBarang} hiddenColumns={[
                            'id', 'mmgudang_sub_opname_id', 'id_barang', 'mmgudang_sub_id',
                            'mmsatuan_id', 'mmsatuan_doc_id', 'created_at', 'qty_system'
                        ]}
                            customRender={[
                                {
                                    key: 'sudah_dipilih',
                                    renderCell: ({ value }: any) => Number(value) === 1
                                        ? <Chip size='small' color='info' label='Sudah dipilih' />
                                        : <Chip size='small' variant='outlined' label='Belum dipilih' />
                                }
                            ]}
                            rowClick={handleClick}
                        />
                    )}
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogBarang(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
